// extracted by mini-css-extract-plugin
export default {"brand":"styles_brand__zRXpS","main_section":"styles_main_section__yC02h","left_banner":"styles_left_banner__H-1LS","right_section":"styles_right_section__s4MNR"};